import { useState } from 'react';
import styled from 'styled-components';
import Theme from '../../../Theme';

import { BgImage, Text } from '../../../components/core';
import ChapterMenuItem from './ChapterMenuItem';
import Indicator from './Indicator';
import grid from '../../../assets/grid.svg';
import PreviewImage from './PreviewImage';
import MenuItems from '../components/MenuItems';
import { chapters } from '../../../other/constants';
import { Arrow, useArrow } from '../Locations/LocationsMenu';
import useMobile from '../../../other/Hooks/useMobile';

const Container = styled.div`
  width: 100%;
  height: ${window.innerHeight}px;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;

  background-color: ${Theme.colors.DarkGrey};
`;

const ChaptersContainer = styled.div`
  height: ${window.innerHeight}px;
  position: relative;
`;

const Header = styled.div`
  padding: 64px 0 21px 0;
  text-align:center;
  

  @media screen and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
    padding: 31px 0 300px 90px;
  }
  
  @media screen and (max-height:${Theme.devices.mobile})and (orientation:landscape){
    padding: 31px 0 60px 90px;
  }

`;
const ChaptersList = styled.div`

  height: calc(100% - 113px);
  overflow:scroll;
  ::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`
const ChapterNameContainer = styled.div`
  position: absolute;
  text-align: center;
  bottom: 40px;  
  width: 40vw;
  right: -7.5vw;
  transform: translate(-50%,0%);
  z-index: 111;
`;

const IndicatorsContainer = styled.div`
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
    top: 200px;
  }
`;
type Props = {
  playVideo: (arg0: number) => void

}
const Chapters = ({ playVideo }: Props) => {
  const { refEl, onScroll, onClick, scrolledTop } = useArrow(true)
  const [selectedChapter, setSelectedChapter] = useState('WELCOME');

  const handleSelectChapter = (chapterName: string) => {
    setSelectedChapter(chapterName);
  };

  const isMobile = useMobile()

  return (
    <Container>
      <BgImage src={grid} alt='grid' zIndex={1} />
      <ChaptersContainer>
        <Header>
          <Text variant='Header2'>TOUR CHAPTERS</Text>
        </Header>
        <ChaptersList ref={refEl} onScroll={onScroll}>
          <MenuItems
            position='left'
            items={
              chapters.map(chapter => {
                return (
                  <ChapterMenuItem
                    key={chapter.index}
                    selected={selectedChapter === chapter.name}
                    name={chapter.name}
                    number={chapter.index}
                    onClick={() => handleSelectChapter(chapter.name)}
                  />
                )
              })
            }
          />
        </ChaptersList>

        {scrolledTop && <Arrow onClick={onClick} left />}

        <Header>
          <Text variant='Header2'>TOUR CHAPTERS</Text>
        </Header>
      </ChaptersContainer>

      <PreviewImage
        src={chapters.filter(chapter => chapter.name === selectedChapter)[0].src}
        playVideo={() => playVideo(chapters.filter(chapter => chapter.name === selectedChapter)[0].timestamp)}
      />
      {
        !isMobile &&
        <ChapterNameContainer>
          <Text variant='Header2'>{selectedChapter}</Text>
        </ChapterNameContainer>
      }
      <IndicatorsContainer>
        {
          chapters.map(chapter => {
            return (
              <Indicator
                key={chapter.index}
                selected={selectedChapter === chapter.name}
                number={chapter.index}
              />
            )
          })
        }
      </IndicatorsContainer>
    </Container>
  );
};

export default Chapters;